import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {ApiService} from '../../shared/services/api.service';
import {User, WishList} from '../../shared/classes/app.models';
import {ModalService} from '../../shared/services/modal.service';
import {AuthenticationService} from '../../shared/services/authentication.service';

@Component({
    selector: 'wishlist-page',
    templateUrl: './wishlist.component.html',
    styleUrls: ['./wishlist.component.scss']
})

export class WishlistComponent implements OnInit, OnDestroy {

    wishList: any;
    currentUser: User;
    share: string;
    isMobile = false;
    private subscr: Subscription;

    constructor(private apiService: ApiService, private  modalService: ModalService,
                private authenticationService: AuthenticationService) {
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);

    }

    public getWishList() {
        this.subscr = this.apiService.getWishList(this.currentUser?.customers_id).subscribe(data => {
            this.wishList = data['data'];
        });
    }

    public remove(wish) {
        this.apiService.removeWishList(wish.id).subscribe(data => {
            if (data['statusCode'] == 200) {
                this.wishList = data['data'];
            }
        });
    }

    public shareList(wish: WishList) {
        this.modalService.showShareModal(wish);
    }

    public onShare(wish) {
        this.apiService.shareLightbox('', wish.id, 0)
            .pipe(
                finalize(() => {
                })
            )
            .subscribe(
                res => {
                    this.share = res.token;
                    this.openSharingPopUp();
                });

    }

    private openSharingPopUp() {
        this.modalService.showSocialSharingModal(this.share);
    }

    ngOnInit(): void {
        if (window.innerWidth < 550) {
            this.isMobile = true;
        }
        this.getWishList();
        // this.subscr = this.wishlistService.wishlistStream.subscribe(items => {
        // 	this.wishItems = items.reduce((acc, product) => {
        // 		let max = 0;
        // 		let min = 999999;
        // 		product.variants.map(item => {
        // 			if (min > item.price) min = item.price;
        // 			if (max < item.price) max = item.price;
        // 		}, []);
        //
        // 		if (product.variants.length == 0) {
        // 			min = product.sale_price
        // 				? product.sale_price
        // 				: product.price;
        // 			max = product.price;
        // 		}
        //
        // 		return [
        // 			...acc,
        // 			{
        // 				...product,
        // 				minPrice: min,
        // 				maxPrice: max
        // 			}
        // 		];
        // 	}, []);
        // });
    }

    ngOnDestroy(): void {
        this.subscr.unsubscribe();
    }
}
